import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="bg-navy text-ivory/70" data-id="element-70" data-mp="3gezdb400vr15">
      <div className="h-px w-full bg-gold/60" aria-hidden="true" data-id="element-71" data-mp="3ggtzeln15p6t" />
      <div className="mx-auto max-w-3xl px-4 py-8 text-center" data-id="element-72" data-mp="32onigxc1ze6b">
        <p className="text-xs" data-id="element-73" data-mp="32m1ch24t96q7">© 2026 {productShortName}. Tutti i diritti riservati.</p>
      </div>
    </footer>;
}